/**
 * KnownThreadStatus is a FE-only enum. The BE just uses a string, but we want to keep status consistent.
 */
export enum KnownThreadStatus {
  NEW = 'new',
  READ = 'read',
  ERROR = 'error',
}

/**
 * OptimisticUpdateStatusDetails is a FE-only enum used to track the status of an optimistic update.
 */
export enum OptimisticUpdateStatusDetails {
  DELETING = 'DELETING',
  SENDING = 'SENDING',
}

/**
 * KnownProgramSlugIds is a FE-only enum. The BE just uses a string, but we want to keep slugIds consistent
 */
export enum KnownProgramSlugIds {
  MANUAL_MESSAGES = 'manual-messages',
  PAYMENT_REMINDERS = 'payment-reminders',
  APPOINTMENTS_REMINDERS = 'appointments-reminders',
  REVIEW_REQUESTS = 'review-requests',
  PRODUCT_READY = 'product-ready',
  BIRTHDAY = 'birthday',
  MESSAGING_PREFERENCES = 'messaging-preferences',
  MISSED_CALL = 'missed-call',
  MARKETING_MESSAGES = 'marketing-messages',
  RECALL = 'recall',
  SAVE_THE_DATE = 'save-the-date',
}
